module.exports = __webpack_public_path__ + "static/media/433522886_1486363362263274_8163768002665527073_n.1c59850d.jpg";